/* ==========================================================================
   SOBO theme runtime — cart drawer (Shopify AJAX Cart API), header menus,
   search panel, free-shipping bar, toast, PDP variant + quantity controls.
   ========================================================================== */
(function () {
  "use strict";

  var money = (window.Shopify && Shopify.currency && Shopify.currency.active) || "GBP";
  var THEME = window.SOBO || {};
  var THRESHOLD = (THEME.freeShippingThreshold != null ? THEME.freeShippingThreshold : 100) * 100; // cents
  var MONEY_FORMAT = THEME.moneyFormat || "£{{amount}}";

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---- money formatting (mirrors Shopify's `money` filter for the common cases) ---- */
  function formatMoney(cents) {
    var value = (cents / 100);
    var format = MONEY_FORMAT;
    function withCommas(num, decimals) {
      var n = (num).toFixed(decimals);
      var parts = n.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      switch (key) {
        case "amount": return withCommas(value, 2);
        case "amount_no_decimals": return withCommas(value, 0);
        case "amount_with_comma_separator": return withCommas(value, 2).replace(/,/g, " ").replace(".", ",");
        case "amount_no_decimals_with_comma_separator": return withCommas(value, 0).replace(/,/g, ".");
        default: return withCommas(value, 2);
      }
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer = null;
  function showToast(msg) {
    var host = $("#sobo-toast");
    if (!host) return;
    host.innerHTML = '<div class="toast">' + msg + "</div>";
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { host.innerHTML = ""; }, 2200);
  }

  /* ---------- Header: shop dropdown (hover handled by CSS), mobile menu, search ---------- */
  function initHeader() {
    var burger = $("[data-sobo-burger]");
    var mobile = $("#sobo-mobile-menu");
    var searchToggle = $all("[data-sobo-search-toggle]");
    var searchPanel = $("#sobo-search-panel");

    if (burger && mobile) {
      burger.addEventListener("click", function () {
        var open = mobile.hasAttribute("hidden");
        if (open) { mobile.removeAttribute("hidden"); if (searchPanel) searchPanel.setAttribute("hidden", ""); }
        else { mobile.setAttribute("hidden", ""); }
      });
    }
    searchToggle.forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!searchPanel) return;
        var open = searchPanel.hasAttribute("hidden");
        if (open) { searchPanel.removeAttribute("hidden"); if (mobile) mobile.setAttribute("hidden", ""); var i = $("input", searchPanel); if (i) i.focus(); }
        else { searchPanel.setAttribute("hidden", ""); }
      });
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer, backdrop;
  function openDrawer() { if (drawer) { drawer.classList.add("open"); backdrop.classList.add("open"); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove("open"); backdrop.classList.remove("open"); } }

  function renderCart(cart) {
    var count = cart.item_count;
    $all("[data-cart-count]").forEach(function (el) { el.textContent = count; });

    // free shipping bar
    var pct = Math.min(cart.total_price / THRESHOLD, 1) * 100;
    var remain = Math.max(0, THRESHOLD - cart.total_price);
    var msg = $("#sobo-ship-msg"), fill = $("#sobo-ship-fill");
    if (msg) msg.textContent = remain > 0
      ? "You're " + formatMoney(remain) + " away from FREE UK shipping"
      : "You've unlocked FREE UK shipping";
    if (fill) fill.style.width = pct + "%";

    var items = $("#sobo-drawer-items");
    var foot = $("#sobo-drawer-foot");
    if (!items) return;

    if (!cart.items.length) {
      items.innerHTML = '<div class="cart-empty"><div class="msg">Your cart is empty</div>' +
        '<button type="button" data-sobo-cart-close>Continue shopping</button></div>';
      if (foot) foot.innerHTML = "";
      return;
    }

    items.innerHTML = cart.items.map(function (it) {
      var size = "";
      if (it.options_with_values && it.options_with_values.length) {
        size = it.options_with_values[0].value;
      } else if (it.variant_title && it.variant_title !== "Default Title") {
        size = it.variant_title;
      }
      var sizeRow = size ? '<div class="lsize">Size ' + size + "</div>" : "";
      var img = it.image ? '<img src="' + it.image + '" alt="' + it.product_title + '">' : "";
      return '<div class="line" data-key="' + it.key + '">' +
        '<div class="thumb">' + img + "</div>" +
        '<div class="body">' +
          '<div class="top"><span class="lname">' + it.product_title + "</span>" +
            '<button class="rm" type="button" data-sobo-remove="' + it.key + '" aria-label="Remove">×</button></div>' +
          sizeRow +
          '<div class="row">' +
            '<div class="mini">' +
              '<button type="button" data-sobo-qty="' + it.key + '" data-delta="-1">−</button>' +
              '<span class="v">' + it.quantity + "</span>" +
              '<button type="button" data-sobo-qty="' + it.key + '" data-delta="1">+</button>' +
            "</div>" +
            "<span>" + formatMoney(it.final_line_price) + "</span>" +
          "</div>" +
        "</div>" +
      "</div>";
    }).join("");

    if (foot) {
      foot.innerHTML = '<div class="drawer-foot">' +
        '<div class="sub"><span class="lbl">Subtotal</span><span>' + formatMoney(cart.total_price) + "</span></div>" +
        '<div class="note">Shipping &amp; taxes calculated at checkout.</div>' +
        '<a class="checkout" href="/checkout">Checkout · ' + formatMoney(cart.total_price) + "</a>" +
      "</div>";
    }
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function addToCart(variantId, quantity) {
    if (drawer) drawer.classList.add("loading");
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { showToast(res.data.description || "Could not add to cart"); return null; }
        return fetchCart().then(function (cart) { openDrawer(); showToast("Added to cart"); return cart; });
      })
      .catch(function () { showToast("Could not add to cart"); })
      .finally(function () { if (drawer) drawer.classList.remove("loading"); });
  }

  function changeLine(key, quantity) {
    if (drawer) drawer.classList.add("loading");
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .finally(function () { if (drawer) drawer.classList.remove("loading"); });
  }

  function initCart() {
    drawer = $("#sobo-drawer");
    backdrop = $("#sobo-backdrop");

    document.addEventListener("click", function (e) {
      var t = e.target;

      var openBtn = t.closest("[data-sobo-cart-open]");
      if (openBtn) { e.preventDefault(); openDrawer(); return; }

      if (t.closest("[data-sobo-cart-close]")) { e.preventDefault(); closeDrawer(); return; }

      var quick = t.closest("[data-sobo-quickadd]");
      if (quick) {
        e.preventDefault(); e.stopPropagation();
        var vid = quick.getAttribute("data-variant-id");
        if (vid) addToCart(vid, 1);
        return;
      }

      var qtyBtn = t.closest("[data-sobo-qty]");
      if (qtyBtn) {
        var key = qtyBtn.getAttribute("data-sobo-qty");
        var delta = parseInt(qtyBtn.getAttribute("data-delta"), 10);
        var line = qtyBtn.closest(".line");
        var cur = parseInt($(".v", line).textContent, 10) || 0;
        changeLine(key, Math.max(0, cur + delta));
        return;
      }

      var rm = t.closest("[data-sobo-remove]");
      if (rm) { changeLine(rm.getAttribute("data-sobo-remove"), 0); return; }
    });

    // initialise counts / bar from current cart
    fetchCart();
  }

  /* ---------- PDP: variant selection (size), quantity, add-to-cart ---------- */
  function initProductForm() {
    var form = $("[data-sobo-product-form]");
    if (!form) return;

    var variants = JSON.parse(form.getAttribute("data-variants") || "[]");
    var selectedId = form.getAttribute("data-current-variant") || (variants[0] && variants[0].id);
    var idInput = $("[data-sobo-variant-id]", form);
    var priceEl = $("[data-sobo-price]");
    var addBtn = $("[data-sobo-add]", form);
    var qtyInput = $("[data-sobo-qty-input]", form);

    function currentVariant() {
      for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === String(selectedId)) return variants[i]; }
      return variants[0];
    }
    function refresh() {
      var v = currentVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.compare_at_price && v.compare_at_price > v.price
        ? "<s>" + formatMoney(v.compare_at_price) + "</s>" + formatMoney(v.price)
        : formatMoney(v.price);
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute("disabled"); addBtn.textContent = "Add to cart — " + formatMoney(v.price); }
        else { addBtn.setAttribute("disabled", ""); addBtn.textContent = "Sold out"; }
      }
    }

    $all("[data-sobo-size]", form).forEach(function (btn) {
      btn.addEventListener("click", function () {
        $all("[data-sobo-size]", form).forEach(function (b) { b.classList.remove("active"); });
        btn.classList.add("active");
        selectedId = btn.getAttribute("data-variant-id");
        refresh();
      });
    });

    $all("[data-sobo-step]", form).forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (!qtyInput) return;
        var d = parseInt(btn.getAttribute("data-sobo-step"), 10);
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + d);
      });
    });

    // PDP gallery thumbnail swap
    $all("[data-sobo-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var full = thumb.getAttribute("data-full");
        var main = $("[data-sobo-main-image]");
        if (full && main) main.setAttribute("src", full);
      });
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = currentVariant();
      if (!v || !v.available) return;
      var q = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      addToCart(v.id, q);
    });

    refresh();
  }

  /* ---------- Collection: client-side category filter (pills) ---------- */
  function initCollectionFilter() {
    var bar = $("[data-sobo-filters]");
    if (!bar) return;
    var cards = $all("[data-sobo-product-card]");
    $all("[data-sobo-filter]", bar).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var val = btn.getAttribute("data-sobo-filter");
        $all("[data-sobo-filter]", bar).forEach(function (b) { b.classList.remove("active"); });
        btn.classList.add("active");
        cards.forEach(function (c) {
          var cats = (c.getAttribute("data-cats") || "").split("|");
          c.style.display = (val === "All" || cats.indexOf(val) !== -1) ? "" : "none";
        });
      });
    });
  }

  /* ---------- Newsletter (thank-you swap; real submit handled by Shopify form) ---------- */
  function initNewsletter() {
    // Shopify customer form posts server-side; this only enhances the inline confirmation
    if (/customer_posted=true/.test(window.location.search)) {
      var slot = $("#sobo-newsletter-slot");
      if (slot) slot.innerHTML = '<div class="news-thanks">Thank you — welcome to SOBO. Check your inbox.</div>';
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    initHeader();
    initCart();
    initProductForm();
    initCollectionFilter();
    initNewsletter();

    // Re-init product form when Shopify theme editor reloads a section
    document.addEventListener("shopify:section:load", function () {
      initProductForm();
      initCollectionFilter();
    });
  });

  window.SOBO = window.SOBO || {};
  window.SOBO.openCart = openDrawer;
  window.SOBO.addToCart = addToCart;
})();
